import { Component, OnInit } from '@angular/core';
import { UserLogicService } from '../../logic/user.service'
import { Router } from '@angular/router';

@Component({
  selector: 'login-pg',
  templateUrl: './login.component.html',
})
export class LoginPage implements OnInit {

  email: string = "";
  password: string = "";

  constructor(private userLogicService: UserLogicService, private router: Router) { }

  ngOnInit(): void {
    let email = localStorage.getItem("email");
    let pass = localStorage.getItem("pass");

    if((email != null && pass != null) &&(email != "" && pass != "")) {
      this.userLogicService.userLoginLogic({ email: email, password: pass }).subscribe((s: any) => {
      localStorage.setItem("user", JSON.stringify(s.data.user))
        this.router.navigate(['/page']);
      },(error: any) => {
        alert(error.error.error.error)
      })
    }
  }

  onLoginSubmit(){
    this.userLogicService.userLoginLogic({ email: this.email, password: this.password }).subscribe((s: any) => {
      localStorage.setItem("email", this.email)
      localStorage.setItem("pass", this.password)
      localStorage.setItem("user", JSON.stringify(s.data.user))
      this.router.navigate(['/page']);
    },(error: any) => {
      alert(error.error.error.error)
    })
  }

}
